// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1XLVl","location":"Header_location__XxB-n"};